<app-container-transparent>

    <div flexLayout="row" [formGroup]="formGroup" style="margin-bottom: 15px;">
        <div fxFlex="20">
            <ng-select [items]="mesList"
                       bindLabel="name"
                       bindValue="id"
                       formControlName="mes"
                       placeholder="Mês">
            </ng-select>
        </div>
        <div fxFlex="20">
            <ng-select [items]="anoList"
                       bindLabel="name"
                       bindValue="id"
                       formControlName="ano"
                       placeholder="Ano">
            </ng-select>
        </div>
        <div fxFlex="5">
            <button mat-button mat-raised-button color="primary" (click)="submitFilter()">Filtrar</button>
        </div>
        <div fxFlex="55"></div>
    </div>

    <div flexLayout="row">
        <div style="display: block;" *ngIf="showChart">
            <canvas baseChart
                    [datasets]="barChartData"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [plugins]="barChartPlugins"
                    [legend]="barChartLegend"
                    [chartType]="barChartType">
            </canvas>
        </div>
    </div>

</app-container-transparent>